import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav style={{
      position: 'fixed', top: 0, width: '100%', zIndex: 50,
      background: scrolled ? 'rgba(8,8,8,0.95)' : 'transparent',
      backdropFilter: scrolled ? 'blur(20px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(201,168,76,0.15)' : 'none',
      transition: 'all 0.4s ease',
      padding: '0 24px',
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '72px' }}>
        
        <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0 }}>
          <span className="brand-font logo-text" style={{ color: '#C9A84C', fontSize: '28px', lineHeight: 1 }}>One</span>
          <span className="brand-font logo-text" style={{ color: '#F0EDE8', fontSize: '28px', lineHeight: 1 }}> Stop Shop</span>
        </Link>

        {/* Desktop Nav */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '28px', flexWrap: 'nowrap' }} className="desktop-nav">
          {[
            { label: 'Land', to: '/land' },
            { label: 'Houses for Sale', to: '/houses-for-sale' },
            { label: 'Houses for Rent', to: '/houses-for-rent' },
            { label: 'Cars', to: '/cars' },
          ].map(link => (
            <Link key={link.to} to={link.to} style={{
              color: '#8A8480', textDecoration: 'none', fontSize: '13px',
              letterSpacing: '0.06em', textTransform: 'uppercase', transition: 'color 0.2s',
              whiteSpace: 'nowrap',
            }}
            onMouseEnter={e => (e.currentTarget.style.color = '#C9A84C')}
            onMouseLeave={e => (e.currentTarget.style.color = '#8A8480')}
            >{link.label}</Link>
          ))}
          <Link to="/my-unlocks" style={{
            color: '#8A8480', textDecoration: 'none', fontSize: '13px',
            letterSpacing: '0.06em', textTransform: 'uppercase', transition: 'color 0.2s',
            whiteSpace: 'nowrap',
          }}
          onMouseEnter={e => (e.currentTarget.style.color = '#C9A84C')}
          onMouseLeave={e => (e.currentTarget.style.color = '#8A8480')}
          >
            🔓 My Unlocks
          </Link>
          <span style={{ color: '#444', fontSize: '12px', letterSpacing: '0.06em', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>
            Courier <span style={{ color: '#C9A84C' }}>Soon</span>
          </span>
          <Link to="/lister-login" style={{
            color: '#8A8480', textDecoration: 'none', fontSize: '13px',
            letterSpacing: '0.06em', textTransform: 'uppercase', transition: 'color 0.2s',
            whiteSpace: 'nowrap',
          }}
          onMouseEnter={e => (e.currentTarget.style.color = '#C9A84C')}
          onMouseLeave={e => (e.currentTarget.style.color = '#8A8480')}
          >
            Lister Login
          </Link>
          <Link to="/lister-signup" className="brand-cta" style={{
            color: '#C9A84C', textDecoration: 'none', fontSize: '17px',
            padding: '4px 14px', border: '1px solid rgba(201,168,76,0.4)', borderRadius: '50px',
            whiteSpace: 'nowrap',
          }}>
            Become a Lister
          </Link>
          <ThemeToggle />
        </div>

        {/* Mobile Hamburger */}
        <button onClick={() => setIsOpen(!isOpen)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#C9A84C', display: 'none' }} className="hamburger">
          <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isOpen
              ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
              : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 6h16M4 12h16M4 18h16" />}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div style={{
          background: 'rgba(8,8,8,0.98)', padding: '24px',
          borderTop: '1px solid rgba(201,168,76,0.1)',
          display: 'flex', flexDirection: 'column', gap: '24px',
        }}>
          {[
            { label: 'Land', to: '/land' },
            { label: 'Houses for Sale', to: '/houses-for-sale' },
            { label: 'Houses for Rent', to: '/houses-for-rent' },
            { label: 'Cars', to: '/cars' },
          ].map(link => (
            <Link key={link.to} to={link.to} onClick={() => setIsOpen(false)} style={{
              color: '#F0EDE8', textDecoration: 'none', fontSize: '16px', letterSpacing: '0.04em',
            }}>{link.label}</Link>
          ))}
          <Link to="/my-unlocks" onClick={() => setIsOpen(false)} style={{
            color: '#F0EDE8', textDecoration: 'none', fontSize: '16px', letterSpacing: '0.04em',
          }}>
            🔓 My Unlocks
          </Link>
          <span style={{ color: '#444', fontSize: '14px' }}>Courier <span style={{ color: '#C9A84C' }}>— Coming Soon</span></span>
          <Link to="/lister-login" onClick={() => setIsOpen(false)} style={{
            color: '#F0EDE8', textDecoration: 'none', fontSize: '16px', letterSpacing: '0.04em',
          }}>
            Lister Login
          </Link>
          <Link to="/lister-signup" onClick={() => setIsOpen(false)} className="brand-cta" style={{
            color: '#C9A84C', textDecoration: 'none', fontSize: '22px', textAlign: 'center',
            padding: '10px', border: '1px solid rgba(201,168,76,0.4)', borderRadius: '50px',
          }}>
            Become a Lister
          </Link>
          <ThemeToggle mobile />
        </div>
      )}

      <style>{`
        @media (max-width: 1024px) {
          .desktop-nav { display: none !important; }
          .hamburger { display: block !important; }
        }
        @media (max-width: 400px) {
          .logo-text { font-size: 22px !important; }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;